// extracted by mini-css-extract-plugin
module.exports = {"container":"dialog_container__hDZBC"};